
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Откройте меню вашего браузера`,
's182ab2d6c997515f': `Добавьте его на экран «Домой» — это откроет дополнительные возможности и сделает использование удобнее.`,
's1b9047d53d9f9d22': `2) Нажмите "Поделиться"`,
's2d90afa5dcca2c0e': `3) Прокрутите вниз до "На экран «Домой»"`,
's37a9e8aec5713460': `Подробнее`,
's4593f304dac8848c': `2) Нажмите "Добавить на главный экран"`,
's54cfbb14f46396d4': `1) Откройте в вашем основном браузере`,
's6196153c4b0c1ea0': `Установить`,
's922329d6f6213590': `Добавить в Dock`,
'sa5ef80b4bb9b39f8': `Свернуть`,
'sa7551383d1897fcc': `2) Нажмите "Добавить в Dock"`,
'sba52286c21552a4e': `Установите это на ваше устройство, чтобы получить дополнительные возможности и удобство использования.`,
'sc79fd7641eb9a975': `Спрятать Инструкцию`,
'scdaf4bbff76674c8': `На экран «Домой»`,
'se740f75b95a51807': `Добавьте его в Dock — это откроет дополнительные возможности и сделает использование удобнее.`,
'sfea652f6580ff086': `Этот веб-сайт имеет функционал приложения.`,
    };
  